<!-- ============================================================================
     "More" mega menu — 3-column card grid + gradient CTA panel.
     The host is a fixed, click-through overlay; only the scrim, the pointer and
     the panel take pointer events.
     ========================================================================= -->

<div class="mmm-scrim" *ngIf="open" @scrim (click)="requestClose()" aria-hidden="true"></div>

<span class="mmm-pointer" *ngIf="open" @scrim aria-hidden="true"></span>

<div
  class="mmm-shell"
  *ngIf="open"
  @panel
  role="dialog"
  aria-label="More from ResilienceSoft"
  (mouseenter)="hoverIn.emit()"
  (mouseleave)="hoverOut.emit()"
>
  <button
    type="button"
    class="mmm-close"
    aria-label="Close menu"
    (click)="requestClose()"
  >
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="m6.5 6.5 11 11m0-11-11 11"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
      />
    </svg>
  </button>

  <div class="mmm-panel">
    <span class="mmm-glow" aria-hidden="true"></span>

    <div class="mmm-grid">
      <ng-container *ngFor="let item of items; trackBy: trackByTitle">
        <!-- live destination -->
        <a
          *ngIf="item.link"
          class="mmm-item"
          [routerLink]="item.link"
          (click)="requestClose()"
        >
          <span class="mmm-item__ico" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                *ngFor="let d of item.icon.p"
                [attr.d]="d"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                *ngFor="let c of item.icon.c"
                [attr.cx]="c[0]"
                [attr.cy]="c[1]"
                [attr.r]="c[2]"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
          </span>

          <span class="mmm-item__copy">
            <span class="mmm-item__title">{{ item.title }}</span>
            <span class="mmm-item__desc">{{ item.desc }}</span>
          </span>
        </a>

        <!-- destination not published yet — inert, so nothing dead-ends -->
        <div *ngIf="!item.link" class="mmm-item mmm-item--soon" aria-disabled="true">
          <span class="mmm-item__ico" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                *ngFor="let d of item.icon.p"
                [attr.d]="d"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle
                *ngFor="let c of item.icon.c"
                [attr.cx]="c[0]"
                [attr.cy]="c[1]"
                [attr.r]="c[2]"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
          </span>

          <span class="mmm-item__copy">
            <span class="mmm-item__title">
              {{ item.title }}
              <span class="mmm-item__chip">Soon</span>
            </span>
            <span class="mmm-item__desc">{{ item.desc }}</span>
          </span>
        </div>
      </ng-container>
    </div>

    <!-- ----------------------------------------------------------- CTA panel -->
    <div class="mmm-cta">
      <span class="mmm-cta__ico" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M21 3L3 10.5l7 2.5 2.5 7L21 3z"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="M10 13l4.5-4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
        </svg>
      </span>

      <div class="mmm-cta__copy">
        <p class="mmm-cta__title">Let's build something amazing together!</p>
        <p class="mmm-cta__text">Have a project in mind? Let's talk and create impact.</p>
      </div>

      <a class="mmm-cta__btn" routerLink="/contact-us" (click)="requestClose()">
        <span>Contact Us</span>
        <span class="mmm-cta__btn-ico" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12h13M13 6l6 6-6 6"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </a>
    </div>
  </div>
</div>
